import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { TextField, Button, Typography, Container, Box } from "@mui/material";

const Contato = () => {
    const [formData, setFormData] = useState({
        nome: "",
        email: "",
        telefone: "",
        mensagem: "",
    });
    const [captchaValue, setCaptchaValue] = useState(null);
    const [mensagem, setMensagem] = useState("");
    const [erroTelefone, setErroTelefone] = useState("");
    const [erroEmail, setErroEmail] = useState("");

    const validarTelefone = (telefone) => {
        const regexTelefone = /^\(?\d{2}\)?\s?(?:9\d{4}|\d{4})[-.\s]?\d{4}$/;
        return regexTelefone.test(telefone);
    };

    // Função para validar o email
    const validarEmail = (email) => {
        const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regexEmail.test(email);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaValue) {
            setMensagem("❌ Complete o reCAPTCHA antes de enviar.");
            return;
        }

        if (formData.telefone  && !validarTelefone(formData.telefone)) {
            setErroTelefone("Telefone inválido");
            return;
        }

        if (!validarEmail(formData.email)) {
            setErroEmail("Email inválido");
            return;
        }

        try {
          
            const resposta = await fetch(`${window.location.origin}/content/contato`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Frontend-Client": "react-app"
                 },
                body: JSON.stringify(formData),
            });

            if (resposta.ok) {
                setMensagem("✅ Mensagem enviada com sucesso!");
                setFormData({ nome: "", email: "", telefone: "", mensagem: "" });
                setCaptchaValue(null);
            } else {
                throw new Error("Erro ao enviar mensagem.");
            }
        } catch (error) {
            setMensagem("❌ Erro ao enviar mensagem. Tente novamente.");
        }
    };
    return (
      <Container maxWidth="sm">
          <Box sx={{ padding: 3, boxShadow: 3, borderRadius: 2, backgroundColor: "#fff" }}>
              <Typography variant="h4" align="center" gutterBottom>
                  Entre em Contato
              </Typography>
              <form onSubmit={handleSubmit}>
                  <TextField
                      label="Nome"
                      name="nome"
                      value={formData.nome}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      required
                  />
                  <TextField
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      error={!!erroEmail}
                      helperText={erroEmail} // Exibe o erro de email
                      required
                  />
                  <TextField
                      label="Telefone"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      placeholder="(11) 91234-5678"
                      error={!!erroTelefone}
                      helperText={erroTelefone}
                  />
                  <TextField
                      label="Mensagem"
                      name="mensagem"
                      value={formData.mensagem}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      multiline
                      rows={4}
                      required
                  />
                  {/* reCAPTCHA v2 */}
                  <ReCAPTCHA
                    sitekey="6LdjBtkqAAAAAK9PEVDkNoZCK77OijPk8PeB1m0R"  // Chave pública para reCAPTCHA v2
                    onChange={handleCaptchaChange}
                  />
                  {mensagem && (
                      <Typography variant="body2" color={mensagem.startsWith("❌") ? "error" : "success"} align="center" sx={{ mt: 2 }}>
                          {mensagem}
                      </Typography>
                  )}
                  <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ mt: 3 }}
                  >
                      Enviar
                  </Button>
              </form>
          </Box>
      </Container>
  );
};

export default Contato;
